import { render, staticRenderFns } from "./BasicUser.vue?vue&type=template&id=dc521e56&scoped=true"
import script from "./BasicUser.vue?vue&type=script&lang=js"
export * from "./BasicUser.vue?vue&type=script&lang=js"
import style0 from "./BasicUser.vue?vue&type=style&index=0&id=dc521e56&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc521e56",
  null
  
)

export default component.exports